// extracted by mini-css-extract-plugin
export default {"container":"ClassCard__container___VCz6w","classLabel":"ClassCard__classLabel___lsTOZ","icon":"ClassCard__icon___EQG5I"};